import http from "infra/http";
import { useQuery } from "react-query";
import { ReservaDetalhesResumidoDto } from "../typings";

function useReservaDetalhes(id?: string) {
  return useQuery(
    [`/v1/reserva/${id}/detalhes`],
    async () => {
      const { data } = await http.get<ReservaDetalhesResumidoDto>(
        `/v1/reserva/${id}/detalhes`
      );
      return data;
    },
    {
      enabled: !!id,
    }
  );
}

export default useReservaDetalhes;
